<template>
  You hereby hold Michael Strain harmless of any and all damages, incidental or otherwise, before during and after the course of any and all interaction.
  Use of this site is at your own risk.  I'll do my best to maintain security and uptime, but make no guarantees whatsoever.
</template>